import axios from 'axios';
import utils from '../utils';

const API = '/api';

let idToken = localStorage.getItem('googleIdToken');

let headers = {
  'Content-Type': 'application/json',
  'Google-Id-Token': idToken,
}

function APIException(error) {
  this.error = error;
}

function api(method, svc) {
  const url = `${API}/${svc}`;
  const params = {
    method,
    url,
    headers: headers,
    withCredentials: true,
  };
  return axios(params).then(
    resp => {
      const result = utils.camelizeKeys(resp.data);
      if ('error' in result) {
        throw new APIException(result.error);
      }

      return result;
    },
  );
}

export default {
  getMetrics(date) {
    let url = `metrics?date=${date}`;

    const result = api('get', url);
    return result;
  },

  refetchData(date) {
    let url = `reload-metrics?date=${date}`;

    const result = api('get', url);
    return result;
  },

  login(idToken) {
    headers['Google-Id-Token'] = idToken;
    let url = 'login';
    const result = api('post', url);
    localStorage.setItem('googleIdToken', idToken);
    return result;
  },

  logout() {
    let url = 'logout';
    api('post', url);
    headers['Google-Id-Token'] = null;
  },

  subscribe() {
    let url = 'subscribe';
    const result = api('post', url);
    return result;
  },

  unsubscribe() {
    let url = 'unsubscribe';
    const result = api('post', url);
    return result;
  },
};
